import { render, staticRenderFns } from "./DealDetails.vue?vue&type=template&id=7a5fbd3d&"
import script from "./DealDetails.vue?vue&type=script&lang=js&"
export * from "./DealDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports